export const DATE_FORMAT = "yyyy-MM-dd"
export const TIME_FORMAT = "HH:mm:ss"
export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss"
export const REPORT_DATE_FORMAT = "yyyy-MM-DD"

/** 백엔드 월 그룹 라벨("2025 May")에 쓰이는 영문 월 이름 (1월=index 0) */
export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
